import { HEALTH_FLAG_LABEL } from "@teamna/shared";
import { Badge } from "./Badge.tsx";

/**
 * The flag "Health note" next to a name (C2): the person answered yes to a health question. The
 * team sees the flag, never the answers. One component, so every list draws it the same way.
 */
export function HealthNoteBadge() {
  return <Badge tone="late">{HEALTH_FLAG_LABEL}</Badge>;
}
